/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Decklists_VisibilityInputs */



/**
* | output |
* | --- |
* | "Decklists Visibility" |
*
* @param {Tfield_Decklists_VisibilityInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_decklists_visibility = /** @type {((inputs?: Tfield_Decklists_VisibilityInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Decklists_VisibilityInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Visibilité des decks")
	if (locale === "es") return /** @type {LocalizedString} */ ("Visibilidad de decks")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Visibilidade das Listas de Deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visibilità Decklist")
	return /** @type {LocalizedString} */ ("Decklists Visibility")
});